// ─────────────────────────────────────────────────────────────────────────────
// Purchasing notifications — avisos de cambio de costo en Purchase Orders (2026-10-31)
//
// Backend: api-portal-manager/src/v3_controllers/purchasingNotifications.ts
//   /v3/purchasing/notifications/check    → compara costos de la PO vs Price Management y crea avisos
//   /v3/purchasing/notifications/list     → { pending, recent, pendingCount }
//   /v3/purchasing/notifications/dismiss  → marca como dismissed por id
// Los items con costo cambiado se desactivan con /v3/pricing/toggle-active en
// Mayaland (3) y Altitude (6). Reactivarlos en Price Management cierra sus avisos.
//
// Por ahora solo TypeUser 1 ve la campana y la card (testing).
// ─────────────────────────────────────────────────────────────────────────────
import { getInformationWithDataV3 } from './CABE';
import { getValueCookie } from './cookieService';

export const DEACTIVATE_COMPANIES = [3, 6];
// Evento de window para que la campana y la card se refresquen al instante.
export const PURCHASING_NOTIFICATIONS_CHANGED = 'purchasingNotificationsChanged';

const ok = (res) => !!(res && res.status && res.status.code === 1);

export const canSeePurchasingNotifications = () => getValueCookie('TypeUser') === '1';

export const notifyPurchasingNotificationsChanged = () =>
    window.dispatchEvent(new Event(PURCHASING_NOTIFICATIONS_CHANGED));

// products: los renglones de la PO ({ itemCode, unitCost }). Devuelve { changed, notConfigured } o lanza.
export const checkPurchaseOrderCosts = async (idCompany, purchaseOrder, products) => {
    const res = await getInformationWithDataV3('/v3/purchasing/notifications/check', {
        idCompany: Number(idCompany),
        purchaseOrder,
        items: products.map((p) => ({ itemCode: p.itemCode, cost: Number(p.unitCost) })),
    });
    if (!ok(res)) throw new Error((res && res.error) || 'Could not check item costs.');
    return res.data;
};

// Desactiva cada item en las companies 3 y 6. Devuelve los que fallaron: [{ itemCode, idCompany }].
export const deactivateItems = async (itemCodes) => {
    const failed = [];
    for (const itemCode of itemCodes) {
        for (const idCompany of DEACTIVATE_COMPANIES) {
            const res = await getInformationWithDataV3('/v3/pricing/toggle-active', { itemCode, idCompany, active: false });
            if (!ok(res)) failed.push({ itemCode, idCompany });
        }
    }
    return failed;
};

export const fetchPurchasingNotifications = async () => {
    const res = await getInformationWithDataV3('/v3/purchasing/notifications/list', {});
    if (!ok(res)) throw new Error('Could not load notifications.');
    return res.data;
};

export const dismissPurchasingNotification = async (id) => {
    const res = await getInformationWithDataV3('/v3/purchasing/notifications/dismiss', { id });
    if (!ok(res)) throw new Error('Could not update the notification.');
    notifyPurchasingNotificationsChanged();
    return res.data;
};
